var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRiskGuageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 224,
    viewBox: "0 0 425 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.985 123.275L106.234 28.4432C42.7277 65.187 0 133.853 0 212.5H109.485C109.485 174.374 130.201 141.085 160.985 123.275Z",
    fill: "#4ED27E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 109.485C231.269 109.485 248.859 114.503 264.015 123.275L318.766 28.4433C287.511 10.358 251.215 0 212.5 0C173.785 0 137.497 10.358 106.234 28.4433L160.985 123.275C176.141 114.503 193.732 109.485 212.5 109.485Z",
    fill: "#FEE17B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.766 28.4432L264.016 123.275C294.799 141.085 315.515 174.374 315.515 212.5H425C425 133.853 382.273 65.187 318.766 28.4432Z",
    fill: "#F84562"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.636 181.396L118.257 142.783C113.396 141.071 109.948 147.557 114.087 150.628L201.647 211.457L201.733 211.3C202.385 211.771 203.068 212.211 203.799 212.595C212.099 217.009 222.41 213.86 226.823 205.559C231.237 197.259 228.088 186.948 219.787 182.534C219.057 182.15 218.311 181.82 217.557 181.545L217.643 181.388L217.636 181.396ZM220.298 202.096C217.8 206.8 211.958 208.583 207.254 206.077C202.55 203.58 200.767 197.738 203.273 193.034C205.77 188.33 211.612 186.547 216.316 189.052C221.02 191.557 222.803 197.392 220.298 202.096Z",
    fill: "#434A60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRiskGuageIcon);
export default __webpack_public_path__ + "static/media/LowRiskGuageIcon.39664a7b4df87f08494b5da3ba7d7d70.svg";
export { ForwardRef as ReactComponent };